module.exports = __webpack_public_path__ + "img/report-model.c81e216a.png";